import axios from "axios";

const telecontrol = "7309882f7dc84832d89971a566e41a85a0a149b1";
const baseURL = "https://britania-api.bcrcx.com/zendesk/telecontrol2";
const zendeskToken = import.meta.env.VITE_API_TOKEN_SECOND;

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export { api, zendeskToken, telecontrol };
